<script setup>

import {computed, ref} from 'vue';
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import EditableTextEditorField from "../../../portal-editable-fields/EditableTextEditorField.vue";
import EditableBtn from "../../../portal-editable-fields/EditableBtn.vue";
import { useRouter, useRoute } from "vue-router";
import Profile from "../Profile/Profile.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const layoutStyle = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style);
const corners = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_corners);

const onboardingStep = computed(() => portalContentAndDesignStore.onboardingStep || 1);
const settingStep = ref(false)
const skippingOnboarding = ref(false);

const router = useRouter();

const setOnboardingStep = (step) => {
    settingStep.value = true;
    axios.post(route('partners_int.page_settings.onboarding.set-step'), {
        step: step
    }).then(response => {
        const status = parseInt(response.data.status || -1);
        if (status === 1) {
            portalContentAndDesignStore.onboardingStep = parseInt(response.data.step);
            console.log('Onboarding step set successfully:', response.data.step);
        }
    }).catch(error => {
        console.error('Error setting onboarding step:', error);
    })
    .finally(() => {
        settingStep.value = false;
    });
};

const skipOnboarding = () => {
    skippingOnboarding.value = true;
    axios.get(route('partners_int.page_settings.onboarding.skip'))
        .then(response => {
            const status = parseInt(response.data.status || -1);
            if (status === 1) {
                const step = parseInt(response.data.step)
                portalContentAndDesignStore.onboardingStep = step;
                if (step === 3) {
                    portalContentAndDesignStore.showOnboarding = false;
                }
                router.push({ name: 'dashboard' });
            }
        }).catch(error => {
            console.error('Error skipping onboarding:', error);
        })
        .finally(() => {
            skippingOnboarding.value = false;
        });
};
</script>

<template>
    <div>
        <div
            v-if="!onboardingStep || onboardingStep === 0 || onboardingStep === 1"
            :class="[
                layoutStyle !== 'none' ? 'bg-white' : '',
                corners,
                layoutStyle === 'border' ? 'border border-gray-200 border-opacity-75' : layoutStyle
              ]"
            class="overflow-hidden"
        >
            <div :class="layoutStyle !== 'none' ? 'p-8' : ''">
                <div class="space-y-8">
                    <div class="space-y-4">
                        <editable-text-field
                            text-type="h2"
                            class="text-lg font-semibold"
                            v-model="portalContentAndDesignStore.translationSettings.portal_onboarding_welcome_msg_title"
                        />
                        <editable-text-editor-field
                            class="pt-dashboard-description text-sm opacity-80 space-y-2"
                            v-model="portalContentAndDesignStore.translationSettings.portal_onboarding_welcome_msg_description"
                        />
                    </div>

                    <editable-btn
                        @click="setOnboardingStep(2)"
                        :loading="settingStep"
                        :disabled="settingStep"
                        :type="portalContentAndDesignStore.getPortalLayoutButtonColorClass"
                        v-model="portalContentAndDesignStore.translationSettings.portal_onboarding_welcome_msg_btn_text"
                    >
                    </editable-btn>
                </div>
            </div>
        </div>

        <template v-else-if="onboardingStep > 1">

            <profile v-if="portalContentAndDesignStore.onboardingStep === 2" />

            <div
                v-else
                id="onboarding"
                class="mb-10 overflow-hidden"
                :class="[
                  layoutStyle !== 'none' ? 'bg-white' : '',
                  corners,
                  layoutStyle === 'border' ? 'border border-gray-200 border-opacity-75' : layoutStyle
                ]"
            >
                <div :class="layoutStyle !== 'none' ? 'p-8' : ''">
                    <div class="space-y-8">
                        <editable-text-editor-field
                            v-if="portalContentAndDesignStore.translationSettings.portal_onboarding_page_details"
                            class="pt-dashboard-description text-sm opacity-80 space-y-2"
                            v-model="portalContentAndDesignStore.translationSettings.portal_onboarding_page_details"
                        />

                        <editable-btn
                            :type="portalContentAndDesignStore.getPortalLayoutButtonColorClass"
                            :loading="skippingOnboarding"
                            :disabled="skippingOnboarding"
                            @click="skipOnboarding"
                            v-model="portalContentAndDesignStore.translationSettings.portal_translation_onboarding_continue_to_portal"
                        />
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>
